import { cn } from '$components'
import { SidebarLeftIcon } from '$components'
import { Button, Tooltip } from '$components'
import { useSidebar } from './hooks/use-sidebar'

export function SidebarResizeButton() {
  const { isOpen, toggleOpen } = useSidebar()

  return (
    <div className={cn(
      'flex items-center w-full px-2.5 py-2.5 justify-center',
      {
        'justify-end': isOpen,
      },
    )}
    >
      <Tooltip content={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}>
        <Button
          variant="secondary"
          size="sm"
          aria-label={`${isOpen ? 'Collapse' : 'Expand'} sidebar`}
          onClick={toggleOpen}
          className="!p-2 hover:text-white rounded-xl"
        >
          <SidebarLeftIcon className="size-4 transition-transform" />
        </Button>
      </Tooltip>
    </div>
  )
}
